import { useEffect, useMemo, useState } from 'react'
import { platformAPI } from '../../services/api'
import { t, formatDateTime } from '../../i18n'
import { PageHeader, SearchInput, Table, Loading, Empty, Chip } from './ui'

const tone = action => action.startsWith('PLATFORM_') ? 'amber' : /DELETE|CANCEL|SUSPEND|DISABLE/.test(action) ? 'red' : /LOGIN/.test(action) ? 'gray' : 'blue'
const label = action => action.toLowerCase().replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())

export default function PlatformActivity() {
  const [logs, setLogs] = useState(null)
  const [search, setSearch] = useState('')
  useEffect(() => { platformAPI.getActivity().then(r => setLogs(r.data.logs)).catch(() => setLogs([])) }, [])

  const shown = useMemo(() => {
    const s = search.toLowerCase()
    return (logs || []).filter(l => !s || `${l.action} ${l.username} ${JSON.stringify(l.meta)}`.toLowerCase().includes(s))
  }, [logs, search])

  return (
    <div>
      <PageHeader title={t('Activity')} subtitle={t('The latest 200 actions across the platform.')}>
        <SearchInput value={search} onChange={setSearch} placeholder={t('Search activity')} />
      </PageHeader>
      {!logs ? <Loading /> : !shown.length ? <Empty>{t('No activity yet.')}</Empty> : (
        <Table head={[t('When'), t('Who'), t('Action'), t('Details')]}>
          {shown.map(l => (
            <tr key={l.id} className="align-top hover:bg-slate-50">
              <td className="whitespace-nowrap px-4 py-3 text-slate-500">{formatDateTime(l.created_at)}</td>
              <td className="px-4 py-3 text-slate-900">{l.username || '—'}</td>
              <td className="px-4 py-3"><Chip tone={tone(l.action)}>{t(label(l.action))}</Chip></td>
              <td className="max-w-md px-4 py-3"><code className="block truncate text-xs text-slate-500" title={JSON.stringify(l.meta)} dir="ltr">{JSON.stringify(l.meta)}</code></td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  )
}
